import {
  Box,
  Grid,
  Button,
  IconButton,
  Tooltip,
  Menu,
  Paper,
  Checkbox,
} from "@mui/material";
import { useState } from "react";
import SaveIcon from '@mui/icons-material/Save';
import LanguageIcon from '@mui/icons-material/Language';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toolIconSx } from './toolbarStyles';

const SetIpInOut = ({source, setSource, destination, setDestination, isPrivateSource, isPrivateDestination, compact = false}) => {
  const [anchorInOut, setAnchorInOut] = useState(false);
  const [checkedInSource, setCheckedInSource] = useState(source === "in" ? true : false);
  const [checkedOutSource, setCheckedOutSource] = useState(source === "out" ? true : false);
  const [checkedInDestination, setCheckedInDestination] = useState(destination === "in" ? true : false);
  const [checkedOutDestination, setCheckedOutDestination] = useState(destination === "out" ? true : false);
  const isAnyChecked = checkedInSource || checkedOutSource || checkedInDestination || checkedOutDestination;

  const [initialCheckedInSource, setInitialCheckedInSource] = useState(false);
  const [initialCheckedOutSource, setInitialCheckedOutSource] = useState(false);
  const [initialCheckedInDestination, setInitialCheckedInDestination] = useState(false);
  const [initialCheckedOutDestination, setInitialCheckedOutDestination] = useState(false);

  const handleChangeInSource = (event) => {
    setCheckedInSource(event.target.checked);
    setCheckedOutSource(!event.target.checked);
  };

  const handleChangeOutSource = (event) => {
    setCheckedInSource(!event.target.checked);
    setCheckedOutSource(event.target.checked);
  };

  const handleChangeInDest = (event) => {
    setCheckedInDestination(event.target.checked);
    setCheckedOutDestination(!event.target.checked);
  };

  const handleChangeOutDest = (event) => {
    setCheckedInDestination(!event.target.checked);
    setCheckedOutDestination(event.target.checked);
  };

  const removeAllSource = () => {
    setCheckedInSource(false);
    setCheckedOutSource(false);
  };
  const removeAllDestination = () => {
    setCheckedInDestination(false);
    setCheckedOutDestination(false);
  };

  const handleClickInOut = (event) => {
    setAnchorInOut(event.currentTarget);

    setInitialCheckedInSource(checkedInSource);
    setInitialCheckedOutSource(checkedOutSource);
    setInitialCheckedInDestination(checkedInDestination);
    setInitialCheckedOutDestination(checkedOutDestination);
  };

  const handleCloseMenu = () => {
    
    setCheckedInSource(initialCheckedInSource);
    setCheckedOutSource(initialCheckedOutSource);
    setCheckedInDestination(initialCheckedInDestination);
    setCheckedOutDestination(initialCheckedOutDestination);
    
    setAnchorInOut(false);
  };

  const applyFilters = () => {
    if(checkedInSource) setSource("in");
    else if(checkedOutSource) setSource("out");
    else if(!checkedInSource && !checkedOutSource) setSource(undefined);

    if(checkedInDestination) setDestination("in");
    else if(checkedOutDestination) setDestination("out");
    else if(!checkedInDestination && !checkedOutDestination) setDestination(undefined);
  };


  return (
    <>
        {compact ? (
          <Tooltip arrow title="Internal/External IPs">
            <IconButton size="small" sx={toolIconSx(isAnyChecked)} onClick={handleClickInOut}>
              <LanguageIcon fontSize="small" style={{ color: isAnyChecked ? "#FFA500" : "inherit" }} />
            </IconButton>
          </Tooltip>
        ) : (
          <Button
            onClick={handleClickInOut}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 10,
                flexDirection: "row",
              }}
            >
              <LanguageIcon
                size="small"
                style={{ color: isAnyChecked ? "#FFA500" : "inherit" }}
              />{" "}
              INTERNAL/EXTERNAL IPs
            </div>
          </Button>
        )}
        
        

        <Menu
          anchorEl={anchorInOut}
          open={anchorInOut}
          onClose={handleCloseMenu}
          PaperProps={{
            sx: {
              width: 350,
              padding: 0
            }
          }}
        >
            <div>
                <Grid container spacing={0.2} margin={1}>
                    <Grid size={6} rowSpan={2}>
                            <Paper
                                sx={{
                                height: "100%",
                                padding: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "space-between"
                                }}
                            >
                                <span>SOURCE</span>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={removeAllSource}
                                    sx={{
                                      '&:hover': {
                                        backgroundColor: '#f44336 !important',
                                        opacity: 0.8,
                                      },
                                    }}
                                >
                                    <DeleteForeverIcon/>
                                </Button>
                            </Paper>
                      </Grid>

                    <Grid size={6}>
                        <Box sx={{display: "flex", flexDirection: "column", gap: 0.2}}>
                            {/* Colonna 1 - Riga 1 */}
                            <Grid xs={6}>
                                <Paper
                                    sx={{
                                    height: "100%",
                                    padding: 2,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between"
                                    }}
                                >
                                    <span>Internal ip</span>
                                    <Checkbox
                                        checked={checkedInSource}
                                        onChange={handleChangeInSource}
                                        sx={{ p: 0 }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Paper>
                            </Grid>

                            <Grid xs={6}>
                                <Paper
                                    sx={{
                                    height: "100%",
                                    padding: 2,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between" // Spinge testo a sinistra e checkbox a destra
                                    }}
                                >
                                    <span>External ip</span>
                                    <Checkbox
                                        checked={checkedOutSource}
                                        onChange={handleChangeOutSource}
                                        sx={{ p: 0 }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Paper>
                              </Grid>
                          </Box>
                      </Grid>
                    
                    <Box
                      sx={{
                        borderBottom: "1px solid white",
                        width: "100%",

                      }}
                    />


                    

                    <Grid size={6} rowSpan={8}>
                        <Paper
                            sx={{
                            height: "100%",
                            padding: 2,
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "space-between" // Spinge testo a sinistra e checkbox a destra
                            }}
                        >
                            <span>DESTINATION</span>
                            <Button
                                variant="contained"
                                color="error"
                                onClick={removeAllDestination}
                                sx={{
                                      '&:hover': {
                                        backgroundColor: '#f44336 !important',
                                        opacity: 0.8,
                                      },
                                    }}
                            >
                                <DeleteForeverIcon/>
                            </Button>
                        </Paper>
                      </Grid>

                    <Grid size={6}>
                        <Box sx={{display: "flex", flexDirection: "column", gap: 0.2}}>
                            {/* Colonna 2 - Riga 1 */}
                            <Grid xs={6}>
                                <Paper
                                    sx={{
                                    height: "100%",
                                    padding: 2,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between" // Spinge testo a sinistra e checkbox a destra
                                    }}
                                >
                                    <span>Internal ip</span>
                                    <Checkbox
                                        checked={checkedInDestination}
                                        onChange={handleChangeInDest}
                                        sx={{ p: 0 }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                    />
                                </Paper>
                              </Grid>

                            <Grid xs={6}>
                                <Paper
                                    sx={{
                                    height: "100%",
                                    padding: 2,
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                    justifyContent: "space-between" // Spinge testo a sinistra e checkbox a destra
                                    }}
                                >
                                    <span>External ip</span>
                                    <Checkbox
                                        checked={checkedOutDestination}
                                        onChange={handleChangeOutDest}
                                        sx={{ p: 0 }}
                                        inputProps={{ 'aria-label': 'controlled' }}
                                        />
                                </Paper>
                              </Grid>
                        </Box>
                      </Grid>
                    <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", mt: 2 }}>
                      <Button color="primary" onClick={applyFilters}>
                        <SaveIcon fontSize="small" sx={{ marginRight: 1 }} />APPLY FILTER
                      </Button>
                    </Box>
                </Grid>
            </div>
        </Menu>
      </>
  );
};

export default SetIpInOut;

